import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import trans from '../../translations.json';

class HospitalizationMapTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
    regions: ['CENTRAL', 'EAST', 'NORTH', 'TORONTO', 'WEST'],
  };

  render() {
    //copy data coming in from props to a new object, remove some items that are too old, and build the new data for table

    var data = Object.values(ReducedData.dataLHIN)
      .filter((item) => item.oh_region)
      .map((item) => {
        return {
          ...item,
          [dict.LHIN]: trans.LHIN[item.oh_region][this.props.lang],
        };
      })
      .sort((a, b) => a.oh_region.localeCompare(b.oh_region))
      .map((item, z) => {
        return {
          index: z,
          [dict.hospitalized]:
            item[dict.hospitalized] &&
            item[dict.hospitalized].toLocaleString(),
          [dict.inICU]:
            item[dict.inICU] && item[dict.inICU].toLocaleString(),
          [dict.bedsTaken]:
            item[dict.bedsTaken] &&
            item[dict.bedsTaken].toLocaleString(),
          [dict.LHIN]: item[dict.LHIN],
        };
      });
    const columns = [
      {
        title: trans.hospitalMap.tableTitle[this.props.lang],
        dataIndex: dict.LHIN,
        key: dict.LHIN,
        width: '40%',
        //...this.getColumnSearchProps('name'),
      },
      {
        title: trans.viewModes.hospitalized[this.props.lang],
        dataIndex: dict.hospitalized,
        key: dict.hospitalized,
        width: '20%',

        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.viewModes.inICU[this.props.lang],
        dataIndex: dict.inICU,
        key: dict.inICU,
        width: '20%',

        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.viewModes.bedsTaken[this.props.lang],
        dataIndex: dict.bedsTaken,
        key: dict.bedsTaken,
        width: '20%',

        //...this.getColumnSearchProps('address'),
      },
    ];
    return (
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default HospitalizationMapTable;
